import * as React from 'react';
import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';
import { Programs, Test_Serieses } from '../../custom';

const TestSeriesesLinkField = (props: FieldProps<Test_Serieses>) => {
    const record = useRecordContext<Test_Serieses>();
    if (!record) {
        return null;
    }
    return (
        <Link
            to={`/test-series?filter=${encodeURIComponent(
                JSON.stringify({ programId: record?.id }),
            )}`}
        >
            Test Series
        </Link>
    );
};

TestSeriesesLinkField.defaultProps = {
    label: 'Test Series',
};

export default TestSeriesesLinkField;
